import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SurveysRouter } from '../../../surveys/types';
import { modules } from '../../modules';

@injectable()
export class SurveysRouterService implements SurveysRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${modules.surveys.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${modules.surveys.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToDetail(id: string) {
    this.history.push(`/${modules.surveys.basename}/${id}`);
  }

  goToPassing(surveyId: string, attemptId: string, sectionIndex: number) {
    const search = `?attempt_id=${attemptId}&section=${sectionIndex}`;

    this.history.push({
      pathname: `/${modules.surveys.basename}/${surveyId}/passing`,
      search,
    });
  }

  goToCompleted(id: string) {
    this.history.push(`/${modules.surveys.basename}/${id}/completed`);
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }

  goToAnalytics(id: string) {
    this.history.push(`/${modules.surveys.basename}/${id}/analytics`);
  }

  goToSurveyUserAnswers(surveyId: string, attemptId: string) {
    this.history.push(
      `/${modules.surveys.basename}/${surveyId}/analytics/${attemptId}`,
    );
  }
}
